import { ColorPaletteTokens, ColorTokens } from '@fluentui/react-components';
import { ExtendedTokens } from './types';
import { AdsUITokens } from '../tokens';

export const shared = {
  componentTokensLight: {
    // /////////////////////////////////////////////////////////////////////////
    // tokens overrides
    // /////////////////////////////////////////////////////////////////////////
  } as ExtendedTokens<AdsUITokens>,

  componentTokensDark: {
    // /////////////////////////////////////////////////////////////////////////
    // tokens overrides
    // /////////////////////////////////////////////////////////////////////////
  } as ExtendedTokens<AdsUITokens>,

  colorTokensLight: {
    // /////////////////////////////////////////////////////////////////////////
    // tokens overrides
    // /////////////////////////////////////////////////////////////////////////
  } as ExtendedTokens<ColorTokens>,

  colorTokensDark: {
    // /////////////////////////////////////////////////////////////////////////
    // tokens overrides
    // /////////////////////////////////////////////////////////////////////////
  } as ExtendedTokens<ColorTokens>,

  colorPalletTokensLight: {
    // /////////////////////////////////////////////////////////////////////////
    // tokens overrides
    // /////////////////////////////////////////////////////////////////////////
  } as ExtendedTokens<ColorPaletteTokens>,

  colorPalletTokensDark: {
    // /////////////////////////////////////////////////////////////////////////
    // tokens overrides
    // /////////////////////////////////////////////////////////////////////////
  } as ExtendedTokens<ColorPaletteTokens>,
};
